import { graphql, useMutation } from 'react-relay/hooks';
import { ONBOARDING_TOOLS, ToolSuggestion } from './toolSuggestion';
import { useSuggestToolMutation } from './__generated__/useSuggestToolMutation.graphql';

export function useSuggestTool() {
    const [commit] = useMutation<useSuggestToolMutation>(graphql`
        mutation useSuggestToolMutation($prompt: String!) {
            suggestOnboardingSolution(prompt: $prompt) {
                toolId
                alternativeToolIds
            }
        }
    `);

    return (prompt: string): Promise<ToolSuggestion> =>
        new Promise((resolve, reject) => {
            commit({
                variables: { prompt },
                onCompleted: (response, errors) => {
                    if (errors?.length) {
                        reject(new Error('Unable to suggest a solution.'));
                        return;
                    }
                    const result = response.suggestOnboardingSolution;
                    const tool = ONBOARDING_TOOLS.find((candidate) => candidate.id === result.toolId);
                    if (!tool) {
                        reject(new Error('Invalid solution recommendation.'));
                        return;
                    }
                    resolve({ tool });
                },
                onError: reject
            });
        });
}
